// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
import i18next from 'i18next';

export default function getColumnHeadersList(t: i18next.TFunction): any {
    return [
        {
            fieldName: 'firstName',
            name: t('first_name'),
            maxWidth: 200,
            minWidth: 80,
            width: 85,
            visible: true,
            className: '',
            maxChar: 15,
        },
        {
            fieldName: 'lastName',
            name: t('last_name'),
            maxWidth: 200,
            minWidth: 80,
            width: 85,
            visible: true,
            className: '',
            maxChar: 15,
        },
        {
            fieldName: 'email',
            name: t('email'),
            maxWidth: 200,
            minWidth: 180,
            width: 190,
            visible: true,
            className: '',
            maxChar: 25,
        },
        {
            fieldName: 'roleName',
            name: t('role'),
            maxWidth: 100,
            minWidth: 100,
            width: 100,
            visible: true,
            className: '',
            maxChar: 15,
        },
        {
            fieldName: 'channelName',
            name: t('channel'),
            maxWidth: 20,
            minWidth: 20,
            width: 100,
            visible: true,
            className: '',
            maxChar: 15,
        },
        {
            fieldName: 'tierName',
            name: t('tier_name'),
            maxWidth: 20,
            minWidth: 20,
            width: 60,
            visible: true,
            className: 'textCenter',
            maxChar: 12,
        },
        {
            fieldName: 'soldToCustomerNbr',
            name: t('add_sold_to_name'),
            maxWidth: 250,
            minWidth: 200,
            width: 100,
            visible: false,
            className: '',
            maxChar: 12,
        },
        {
            fieldName: 'shiptoCustomerNbr',
            name: t('add_ship_to_name'),
            maxWidth: 250,
            minWidth: 200,
            width: 100,
            visible: false,
            className: '',
            maxChar: 12,
        },
        {
            fieldName: 'enableWarrantyUpdate',
            name: t('enable_warranty_update'),
            minWidth: 350,
            maxWidth: 500,
            width: 184,
            visible: false,
            className: '',
            maxChar: 12,
        },
        {
            fieldName: 'action',
            name: t('action'),
            minWidth: 350,
            maxWidth: 500,
            width: 100,
            visible: false,
            className: 'textCenter',
            maxChar: 12,
        },
    ];
}
